/**
 * Pilot footer — Oatmeal FooterWithLinkCategories scaled down for the pilot
 * (Planapus copyright, methodology link, talk-to-us button).
 *
 * The talk-to-us footer button piggybacks on the same #topbar-talk
 * modal trigger that `wirePilotModals()` (lib/pilot/modals.js) binds
 * to the talk-modal flow at boot. The methodology link points to the
 * HashRouter route /#/pilot/methodology.
 */

import React from 'react';
import {clsx} from 'clsx/lite';
import {
  FooterWithLinkCategories,
  FooterCategory,
  FooterLink,
} from '../../oatmeal/sections/footer-with-link-categories';
import {usePilot} from './PilotContext';

export default function PilotFooter() {
  const {viewMode} = usePilot();
  // F17 Slice D: pilot-footer was hidden in pitch/demo/vision modes
  // by `body.X-mode .pilot-footer { display: none !important }` rules
  // in pilot-engine.css. Now driven by React state — Tailwind's
  // `hidden` utility = display: none, same outcome.
  const isStoryMode = viewMode === 'story' || viewMode === 'sandbox';

  const handleTalkClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const trigger = document.querySelector('#topbar-talk') as HTMLButtonElement | null;
    if (trigger) {
      trigger.click();
      return;
    }
    const backdrop = document.querySelector('#talk-modal');
    if (backdrop) backdrop.classList.add('open');
  };

  return (
    <FooterWithLinkCategories
      id="pilot-footer"
      className={clsx('pilot-footer', !isStoryMode && 'hidden')}
      links={
        <FooterCategory title="Pilot">
          <FooterLink href="#/pilot/methodology">Methodology</FooterLink>
          <FooterLink href="#" onClick={handleTalkClick} id="pilot-footer-talk">
            Book a walkthrough
          </FooterLink>
        </FooterCategory>
      }
      fineprint={<>&copy; Planapus 2026</>}
    />
  );
}
